import React from 'react';

import PageHeader from '../../Common/PageHeader';
import ProcessingIndicator from '../../Common/ProcessingIndicator';

import Field from '../../Fields/Field';
import InputSelectField from '../../Fields/InputSelectField';

import { queryListFacilities } from '../../../Queries';

import {
  getFacility,
  facilityQueryFields
} from '../../../Utils/facility';

import featureFlags from '../../../featureFlags';

import '../Page.scss';
import './BillingDashboardPage.scss';


class BillingDashboardPage extends React.Component {
  state = {
    pageInitializationComplete: false,
    fetchFacilityQueryInProgress: false,
    facilityId: null,
    facility: null
  };

  inputFacilityOptions = [];


  constructor(props) {
    super(props);

    const urlSearchParams = new URLSearchParams(window.location.search);

    const facilityId = urlSearchParams.get('facility');
    if (facilityId) this.state.facilityId = facilityId;
  }


  async componentDidMount() {
    try {
      if (this.state.facilityId) {
        await this.fetchFacility();
      } else {
        const response = await queryListFacilities(null, facilityQueryFields);
        if (response.errors) {
          throw response.errors;
        }

        this.inputFacilityOptions = response.data.listFacilities.map(facility => (
          { value: facility.uid, label: facility.facility_name }
        ));
      }
    } catch (error) {
      console.log(error);
    }

    this.setState({ pageInitializationComplete: true });
  }


  async fetchFacility() {
    const { facilityId } = this.state;

    this.setState({ fetchFacilityQueryInProgress: true });

    const facility = await getFacility(facilityId);

    this.setState({
      facility,
      fetchFacilityQueryInProgress: false,
    });
  }


  handleInputSelectFacilityChange = async (newValue) => {
    this.setState({ facilityId: newValue }, async () => {
      if (!newValue) return;

      await this.fetchFacility();
      const url = `${window.location.origin}${window.location.pathname}${window.location.search}&facility=${newValue}${window.location.hash}`;
      window.history.replaceState(null, null, url);
    });
  }

  renderPageHeader() {
    const { facility } = this.state;

    const heading = 'Billing Dashboard';
    const subheading = facility?.fields.facility_name.value ?? null;

    return (
      <PageHeader
        heading={heading}
        subheading={subheading}
      />
    );
  }


  render() {
    const {
      pageInitializationComplete,
      fetchFacilityQueryInProgress,
      facilityId,
      facility
    } = this.state;

    const facilityScopeLinkParameter = (facilityId !== null) ?
      `&facility=${facilityId}` : '';

    return (
      <div className="parkchirp--page">
        {this.renderPageHeader()}
        {(!pageInitializationComplete) &&
          <div className="parkchirp--page--user-message-container">
            <ProcessingIndicator userMessage="Retrieving data..." />
          </div>
        }
        {(pageInitializationComplete) &&
          <React.Fragment>
            {(facility === null) &&
              <Field label="Please select a Facility:"
                id="parkchirp--billing-dashboard--facility"
                layout="stacked"
                containerClasses={[ 'parkchirp--billing-dashboard--facility-field-container' ]}>
                <InputSelectField inputId="parkchirp--billing-dashboard--facility"
                  value={facilityId}
                  options={[ { value: null, label: '' }, ...this.inputFacilityOptions ]}
                  onChange={this.handleInputSelectFacilityChange}
                  editMode={true}
                  disabledMode={fetchFacilityQueryInProgress}
                />
                {(fetchFacilityQueryInProgress) &&
                  <ProcessingIndicator />
                }
              </Field>
            }
            {(facility !== null) &&
              <React.Fragment>
                <div className="parkchirp--billing--container-navigation">
                  {/* <div className="parkchirp--page-heading">Facility Configuration</div> */}
                  {/* <ul className="parkchirp--billing--navigation-links"> */}
                    {/* <li>
                      <a href={`?page=parkchirp_billing_profiles${facilityScopeLinkParameter}`} className="button button-primary">Manage Billing Profiles</a>
                    </li> */}
                    {/* <li>
                      <a href={`?page=parkchirp_rates${facilityScopeLinkParameter}`} className="button button-primary">Manage Rates</a>
                    </li> */}
                    {/* <li>
                      <a href={`?page=parkchirp_general_settings${facilityScopeLinkParameter}`} className="button button-primary">General Settings</a>
                    </li> */}
                    {/* <li>
                      <a href={`?page=parkchirp_reports${facilityScopeLinkParameter}`} className="button button-primary">Reports</a>
                    </li> */}
                  {/* </ul> */}
                  <div className="parkchirp--page-heading">Parker Management</div>
                  <ul className="parkchirp--billing--navigation-links">
                    {/* <li>
                      <a href={`?page=parkchirp_subscriptions${facilityScopeLinkParameter}`} className="button button-primary">Subscriptions</a>
                    </li> */}
                    {/* <li>
                      <a href={`?page=parkchirp_invoices${facilityScopeLinkParameter}`} className="button button-primary">Invoice Database</a>
                    </li> */}
                    {/* {featureFlags.CREDITS && (
                      <li>
                        <a href={`?page=parkchirp_credits${facilityScopeLinkParameter}`} className="button button-primary">Credits</a>
                      </li>
                    )} */}
                  </ul>
                </div>
              </React.Fragment>
            }
          </React.Fragment>
        }
      </div>
    );
  }
}

export default BillingDashboardPage;


export function getBillingDashboardPageBreadcrumb(currentPage = true, facilityId = null) {
  const title = 'Billing Dashboard';
  const href = currentPage ? null : `?page=parkchirp_billing${facilityId ? `&facility=${facilityId}` : ''}`;

  return { title, href };
}
